import { render, staticRenderFns } from "./EmailHelpModal.vue?vue&type=template&id=2067309a&"
import script from "./EmailHelpModal.vue?vue&type=script&lang=js&"
export * from "./EmailHelpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports